module.exports = __webpack_public_path__ + "img/r3.5f3e5ed8.png";